// path: src/pages/IPA/Negociacoes/pages/NegociacaoFornecedor/components/Modals/CriarNegociacaoArquivo/nivelDoUpload.ts

/** O que cada nível do upload pede, e quais textos ele mostra. */

export type NivelDoUpload = 'LOJA' | 'CLUSTER' | 'REDE';

export type TextosDaSelecao = {
  rotulo: string;
  placeholder: string;
  buscaPlaceholder: string;
};

const TEXTOS_POR_NIVEL: Record<NivelDoUpload, TextosDaSelecao | null> = {
  LOJA: {
    rotulo: 'Lojas',
    placeholder: 'Selecione as lojas',
    buscaPlaceholder: 'Busque uma loja',
  },
  CLUSTER: {
    rotulo: 'Clusters',
    placeholder: 'Selecione os clusters',
    buscaPlaceholder: 'Busque um cluster',
  },
  // Rede não tem par de textos porque o campo de seleção não é exibido: a negociação é a rede toda, e
  // não há loja nem cluster a escolher.
  REDE: null,
};

/** Se o nível exige que o comprador escolha lojas ou clusters antes de confirmar. */
export const nivelPedeSelecao = (nivel?: NivelDoUpload | string | null): boolean => {
  if (nivel === 'REDE') return false;
  return true;
};

/**
 * O rótulo do campo de seleção e os textos de busca do nível, ou nada quando o campo não é exibido.
 */
export const textosDaSelecaoDoNivel = (nivel?: NivelDoUpload | string | null): TextosDaSelecao | null => {
  if (!nivel) return null;
  return TEXTOS_POR_NIVEL[nivel as NivelDoUpload] ?? null;
};

/** O tipo de exibicao que o servidor entende, a partir do nivel escolhido na tela. */
const TIPO_DE_EXIBICAO_POR_NIVEL: Record<NivelDoUpload, string> = {
  LOJA: 'PRODUCT_SUPPLIERS_STORE',
  CLUSTER: 'PRODUCT_SUPPLIERS_CLUSTER',
  REDE: 'PRODUCT_SUPPLIERS_NETWORK',
};

export const tipoDeExibicaoDoNivel = (nivel: NivelDoUpload): string => TIPO_DE_EXIBICAO_POR_NIVEL[nivel];

/**
 * O nome do campo que carrega a lista de identificadores daquele nivel, ou nada quando o nivel nao
 * tem localidade a apontar.
 */
const CAMPO_DE_IDENTIFICADORES_POR_NIVEL: Record<NivelDoUpload, string | null> = {
  LOJA: 'storeId',
  CLUSTER: 'clusterId',
  REDE: null,
};

export const campoDeIdentificadoresDoNivel = (nivel: NivelDoUpload): string | null =>
  CAMPO_DE_IDENTIFICADORES_POR_NIVEL[nivel];
